import classNames from "classnames";
import React from "react";

const EventCardColumnMessage = ({
  message,
  isError = false,
}: {
  message: string;
  isError?: boolean;
}) => {
  if (!message) return null;

  return (
    <div className="cw-border cw-border-1 cw-border-solid cw-rounded-md cw-border-default">
      <div
        className={classNames("cw-body-base cw-mx-5 cw-my-2", {
          "cw-text-muted": !isError,
          "cw-text-warning": isError,
        })}
      >
        {message}
      </div>
    </div>
  );
};

export default EventCardColumnMessage;
